import { PLACEHOLDER_IMAGE } from "../constants/images";

// Track which images are already pre-loaded
const preloadedImages = new Set<string>();

/**
 * Returns a valid image URL, falling back to placeholder if the provided URL is invalid
 */
export const getImageUrl = (imageUrl?: string): string => {
  if (!imageUrl) return PLACEHOLDER_IMAGE;
  return imageUrl;
};

/**
 * Preload the placeholder image to ensure it's cached
 */
export const preloadPlaceholderImage = (): void => {
  if (!preloadedImages.has(PLACEHOLDER_IMAGE)) {
    const img = new Image();
    img.src = PLACEHOLDER_IMAGE;
    preloadedImages.add(PLACEHOLDER_IMAGE);
  }
};
